// import React from "react";

// export default function LeadForm() {
//   return (
//     <form
//       name="pilot"
//       method="POST"
//       action="/success"
//       data-netlify="true"
//       netlify-honeypot="bot-field"
//       style={{ display: "grid", gap: 14, maxWidth: 520 }}
//     >
//       <input type="hidden" name="form-name" value="pilot" />
//       <p style={{ display: "none" }}>
//         <label>Ne pas remplir: <input name="bot-field" /></label>
//       </p>

//       <label>
//         Nom complet
//         <input name="name" type="text" required />
//       </label>

//       <label>
//         Entreprise
//         <input name="company" type="text" required />
//       </label>

//       <label>
//         Email professionnel
//         <input name="email" type="email" required />
//       </label>

//       <label>
//         Taille de votre équipe
//         <select name="team_size" required>
//           <option value="">Sélectionnez</option>
//           <option>1–10</option>
//           <option>11–50</option>
//           <option>51–200</option>
//           <option>200+</option>
//         </select>
//       </label>

//       <label>
//         Nombre de joueurs souhaité pour le test
//         <select name="players" required>
//           <option value="">Sélectionnez</option>
//           <option>4</option>
//           <option>5</option>
//           <option>6</option>
//         </select>
//       </label>

//       <label>
//         Disponibilité idéale pour le test
//         <select name="availability" required>
//           <option value="">Sélectionnez</option>
//           <option>Décembre</option>
//           <option>Janvier</option>
//           <option>Février</option>
//         </select>
//       </label>

//       <label>
//         Mode de travail
//         <select name="work_mode" required>
//           <option value="">Sélectionnez</option>
//           <option>100 % remote</option>
//           <option>Hybride</option>
//           <option>Présentiel</option>
//         </select>
//       </label>

//       <label>
//         Message (optionnel)
//         <textarea name="message" rows="4" placeholder="Précisez vos attentes ou le contexte..."></textarea>
//       </label>

//       <label style={{ display: "flex", alignItems: "center", gap: 8 }}>
//         <input type="checkbox" name="consent" required />
//         J’accepte d’être recontacté pour participer au programme pilote.
//       </label>

//       <button type="submit">Rejoindre le programme pilote</button>
//     </form>
//   );
// }
import React from "react";
import { useNavigate } from "react-router-dom";

const encode = (data) =>
  Object.keys(data)
    .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(data[k]))
    .join("&");

export default function LeadForm() {
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.target;
    const formData = new FormData(form);
    const data = Object.fromEntries(formData.entries());

    try {
      await fetch("/", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: encode({ "form-name": form.getAttribute("name"), ...data }),
      });
      navigate("/success"); // ✅ redirection SPA
    } catch (err) {
      console.error(err);
      alert("Oups, impossible d’envoyer le formulaire. Réessayez plus tard.");
    }
  };

  return (
    <form
      name="pilot"
      method="POST"
      data-netlify="true"
      netlify-honeypot="bot-field"
      onSubmit={handleSubmit}
    >
      <input type="hidden" name="form-name" value="pilot" />
      <p style={{ display: "none" }}>
        <label>Ne pas remplir: <input name="bot-field" /></label>
      </p>

      {/* <label>
        Nom complet
        <input name="name" type="text" autoComplete="name" required />
      </label> */}

   <label>
        Email professionnel*
        <input name="email" type="email" autoComplete="email" required />
      </label>
      <label>
        Entreprise*
        <input name="company" type="text" autoComplete="organization" required />
      </label>

   

      <label>
        Taille de votre équipe*
        <select name="team_size" required defaultValue="">
          <option value="" disabled>Choisir…</option>
          <option>1–10</option>
          <option>11–50</option>
          <option>51–200</option>
          <option>200+</option>
        </select>
      </label>

     

    
      {/* <label>
        Mode de travail
        <select name="work_mode" required defaultValue="">
          <option value="" disabled>Choisir…</option>
          <option>100 % remote</option>
          <option>Hybride</option>
          <option>Présentiel</option>
        </select>
      </label> */}

       <label>
        Nombre de joueurs souhaité pour le test (optionnel)
        <select name="players"  defaultValue="">
          <option value="" disabled>Choisir…</option>
          <option>4</option>
          <option>5</option>
          <option>6</option>
        </select>
      </label>

        <label>
        Disponibilité idéale (optionnel)
        <select name="availability"  defaultValue="">
          <option value="" disabled>Choisir…</option>
          {/* <option>Décembre</option> */}
          <option>Janvier</option>
          <option>Février</option>
        </select>
      </label>

        <label>
        Employés en full remote (optionnel)
        <select name="full_remote_employes"  defaultValue="">
          <option value="" disabled>Choisir…</option>
          <option>0-5</option>
          <option>6-10</option>
          <option>11-15</option>
          <option>15+</option>
        </select>
      </label>

          {/* <label>
        Ordre de budget pour un team building - Par session de 6 personnes (optionnel)
        <select name="budget"  defaultValue="">
          <option value="" disabled>Choisir…</option>
          <option>Moins de 150€</option>
          <option>150-300€</option>
          <option>300-600€</option>
          <option>600-1000€</option>
          <option>Je ne sais pas</option>
        </select>
      </label> */}

       <label>
        Fréquence des activités d'entreprise (optionnel)
        <select name="team_activities_frequency"  defaultValue="">
          <option value="" disabled>Choisir…</option>
          <option>Jamais</option>
          <option>1x/an</option>
          <option>2-4x/an</option>
          <option>Plus de 4x/an</option>
        </select>
      </label>

      <label>
        Rôle du contact (optionnel)
        <select name="contact_role"  defaultValue="">
          <option value="" disabled>Choisir…</option>
          <option>RH</option>
          <option>Office Manager</option>
          <option>Team Lead</option>
          <option>Dirigeant</option>
          <option>Autre</option>
        </select>
      </label>


      {/* <label>
        Message (optionnel)
        <textarea name="message" rows="4" placeholder="Précisez vos attentes ou le contexte..."></textarea>
      </label> */}

      <label style={{display:"flex", alignItems:"center", gap:8}}>
        <input type="checkbox" name="consent" required />
        J’accepte que mes données soient utilisées uniquement pour être recontacté dans le cadre de la phase pilote Blackout Games.
      </label>

      <button className="btn btn--primary" type="submit">
        Rejoindre le programme pilote
      </button>
    </form>
  );
}
